import { Component, inject, Input } from "@angular/core";
import { OnBackDirective } from "@bitwarden/web-vault/app/directives/onBack.directive";
import { IReferenceData } from "@bitwarden/web-vault/app/models/view/reference-data/reference-data.view";
import { TransactionStoreService } from "@bitwarden/web-vault/app/services/store/transaction/transaction.store.service";

@Component({
  selector: "app-price-details",
  templateUrl: "./price-details.component.html",
})
export class PriceDetailsComponent extends OnBackDirective {
  @Input() price: IReferenceData;
  @Input() closeDialog: CallableFunction;

  private transactionStore = inject(TransactionStoreService);

  getBadgeClass(source: string): string {
    const lower = (source || "").toLowerCase();
    if (lower === "manual" || lower.includes("manual")) {
      return "tw-bg-[#6E56CF33] tw-text-[#6E56CF] tw-rounded-xl";
    }
    return "tw-text-dt-custom-teal-11 tw-bg-[#00C4C433] tw-rounded-xl";
  }

  getSourceLabel(source: string): string {
    if (!source) {
      return "";
    }
    const lower = source.toLowerCase();
    if (lower === "manual" || lower.includes("manual")) {
      return "Manually Entered";
    }
    if (
      lower.includes("gloss-fx") ||
      lower.includes("eodhd") ||
      lower.includes("auto") ||
      lower.includes("fetch")
    ) {
      return "Auto Fetch";
    }
    return source;
  }

  close(): void {
    if (typeof this.closeDialog === "function") {
      this.closeDialog();
    }
  }

  async deletePrice(): Promise<void> {
    const allRefData = this.transactionStore.referenceData.referenceDataViews();
    const matchingRef = allRefData.find(
      (rd) =>
        rd.base === this.price.base &&
        rd.symbol === this.price.symbol &&
        rd.date?.date === this.price.date?.date &&
        rd.source === this.price.source,
    );
    if (!matchingRef) {
      return;
    }
    await this.transactionStore.referenceData.deleteFromVault([matchingRef]);
    this.close();
  }
}
